// extracted by mini-css-extract-plugin
export const root = "OurPartners-module--root--26GiO";
export const title = "OurPartners-module--title--1GBnV";
export const logotypes = "OurPartners-module--logotypes--GYddO";
export const amadeusLogo = "OurPartners-module--amadeus-logo--1-yD3";
export const sabreLogo = "OurPartners-module--sabreLogo--3kTGu";